"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const badges = [{
  id: 1,
  name: "American Academy of Sleep Medicine Member",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621270/img/aasm_member_logo.png",
  alt: "AASM Member Logo"
}, {
  id: 2,
  name: "HIPAA Compliant Practice",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621270/img/hipaa_compliant_badge.png",
  alt: "HIPAA Compliant Badge"
}, {
  id: 3,
  name: "FDA Cleared Medical Devices",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621270/img/fda_cleared_logo.png",
  alt: "FDA Cleared Devices Logo"
}, {
  id: 4,
  name: "Major Insurance Providers Accepted",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621270/img/insurance_accepted_badge.png",
  alt: "Insurance Accepted Badge"
}];
export default function OurCareStandards() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="125494" id="recognized-excellence" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex justify-center mb-4">
            <div className="inline-flex items-center justify-center rounded-full bg-primary/10 p-3">
              <ShieldCheck className="size-6 text-primary" aria-hidden="true" />
            </div>
          </div>
          <h2 className="text-base/7 font-bold text-primary tracking-widest uppercase">
            Certified Excellence
          </h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-foreground sm:text-6xl font-sans">
            Recognized Standards in Sleep Medicine
          </p>
          <p className="mt-6 text-lg/8 text-muted-foreground">
            Our Los Angeles practice is committed to the highest clinical standards, 
            utilizing FDA-cleared devices and adhering to strict AASM protocols to 
            ensure your safety and restorative sleep.
          </p>
        </div>

        <div ref={gridRef} className={`mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="grid grid-cols-2 gap-x-8 gap-y-12 sm:grid-cols-4 items-center justify-items-center">
            {badges.map((badge, i) => <div key={badge.id} data-index={i} className="group relative flex items-center justify-center p-4 w-full max-w-[200px] aspect-[3/2]">
                <img src={badge.image} alt={badge.alt} className="max-h-full max-w-full object-contain filter grayscale opacity-60 transition-all duration-500 ease-in-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105" />
                <span className="sr-only">{badge.name}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}